import React from 'react';
import Calculators from '../components/calculator';

const Calculator = () => (
  <div className="home">
    <br />
    <br />

    <h3>Lets do some Math</h3>
    <br />
    <br />
    <div className="contain">
      <Calculators />
    </div>

  </div>
);

export default Calculator;
